import { sanPhamPhamViApi } from '../../../api/san-pham/sanPhamPhamViApi';
import { IBaseRespone } from '../../../model/respone/IBaseRespone';
import { ISanPhamPhamVi } from '../../../model/respone/san-pham/ISanPhamPhamVi';
import { eSanPhamPhamViActionTypeIds, ISanPhamPhamViActions } from '../../action-types/san-pham/ISanPhamPhamViActionType';

import { rootActions } from '../../actions/rootActions';

import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
const mainAction = rootActions.sanPham.sanPhamPhamVi;

export function* sanPhamPhamViSaga(): any {
    yield takeLatest(eSanPhamPhamViActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eSanPhamPhamViActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eSanPhamPhamViActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: ISanPhamPhamViActions): any {
    const payload = action.payload as { dm_coso_id?: number } | undefined;
    const cosoId = parseInt(localStorage.getItem("dm_coso_id") ?? "0") || 0;
    const requestParams: { dm_coso_id: number } = {
        dm_coso_id: payload?.dm_coso_id || cosoId,
    };

    const res: IBaseRespone = yield call(sanPhamPhamViApi.GetAll, requestParams)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveWorker(action: ISanPhamPhamViActions): any {
    let res: IBaseRespone;
    const sanPhamPhamVi = action.payload as ISanPhamPhamVi;
    if (sanPhamPhamVi.id > 0) {
        res = yield call(sanPhamPhamViApi.Update, sanPhamPhamVi)
    } else {
        res = yield call(sanPhamPhamViApi.Insert, sanPhamPhamVi)
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data))
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
    }
}

function* deleteWorker(action: ISanPhamPhamViActions): any {
    const res: IBaseRespone = yield call(sanPhamPhamViApi.Delete, action.payload as number)
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data))
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"))
    }
}
